<script setup lang="ts">
  import { Typo } from '@travelata-libs/ui-kit';
  import { formatMoney } from '@travelata-libs/utils';
  import { computed, unref } from 'vue';
  import { Direction, DirectionType, type TransferModelValue } from '../Transfer.types';

  interface TransferFooterProps {
    modelValue: TransferModelValue;
  }

  const props = defineProps<TransferFooterProps>();

  const innerValue = computed(() => props.modelValue);

  const resultInfo = computed(() => {
    const model = unref(innerValue);
    const isTherePublic = model[Direction.There].type === DirectionType.Public;
    const isBackPublic = model[Direction.Back].type === DirectionType.Public;

    if (isTherePublic && isBackPublic) {
      return 'Вы добираетесь самостоятельно';
    }

    if (isTherePublic || isBackPublic) {
      return 'У вас трансфер только в одну сторону';
    }

    return 'У вас трансфер туда и обратно';
  });

  const resultPrice = computed(() => {
    const model = unref(innerValue);

    return formatMoney(model[Direction.There].price + model[Direction.Back].price);
  });
</script>

<template>
  <div class="tl-transfer-result">
    <div v-if="$slots.default" class="tl-transfer-result__slot">
      <slot />
    </div>

    <div class="tl-transfer-result__main">
      <Typo variant="body-m-400" class="tl-transfer-result__main-info">{{ resultInfo }}</Typo>
      <Typo variant="h-6" class="tl-transfer-result__main-price">{{ resultPrice }}</Typo>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .tl-transfer-result {
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media (max-width: $breakpoint-mobile-max) {
      flex-direction: column;
      justify-content: flex-start;
    }

    &__slot {
      @media (max-width: $breakpoint-mobile-max) {
        border-bottom: 1px dashed var(--color-text-tertiary);
        margin-bottom: var(--spacing-m);
        padding-bottom: var(--spacing-m);
      }
    }

    &__main {
      align-items: end;
      display: flex;
      flex-direction: column;
      gap: var(--spacing-xxs);
      margin-left: auto;
      text-align: end;

      @media (max-width: $breakpoint-mobile-max) {
        flex-direction: row;
        justify-content: space-between;
        margin-left: unset;
        text-align: start;
      }

      &-info {
        color: var(--color-text-secondary);
      }

      &-price {
        color: var(--color-text-primary);
      }
    }
  }
</style>
